import { Module } from 'vuex';
import { Floor } from '@/utils/api';
import { RootState } from '..';
import getFloorByID from '@/utils/helpers/getFloorByID';
import getAdditionalPrice from '@/utils/helpers/getAdditionalPrice';
import { FloorState } from '@/store/modules/app';

const RESET_STATE = 'RESET_STATE';

const roofShapeInitialState = (): FloorState => ({
  floorID: 'ROF',
  zoneID: 'ROZ'
});

export const roofShapeModule: Module<FloorState, RootState> = {
  namespaced: true,
  state: roofShapeInitialState(),
  getters: {
    floor(_state, _getters, rootState): Floor | undefined {
      const floor: Floor | undefined = getFloorByID(
        rootState.configuration.houseConfiguration?.floors || [],
        _state.floorID,
        _state.zoneID
      );

      if (floor?.zones[0]?.modules) {
        floor.zones[0].modules = getAdditionalPrice(floor.zones[0].modules);
      }

      return floor;
    }
  },
  actions: {
    resetState({ commit }) {
      commit(RESET_STATE);
    }
  },
  mutations: {
    [RESET_STATE](state) {
      Object.assign(state, roofShapeInitialState());
    }
  }
};
